module.exports = "pegasus/assets/tech/email1-img12.png";